import styled from 'styled-components';


const AppLayoutWrapper = styled.div`
    padding: 50px 30px;
    min-height:70vh;
    @media (min-width: 1400px) {
        max-width: 1620px;
    }
`;

export default AppLayoutWrapper;